import { SaveButton } from '@components/action-button/save';

export const ActionButton = {
  Save: SaveButton
};
